import {IAppliedRule, RuleOperator, RuleResultType} from '../incase-domain/appliedRules';

export const isRuleInFocus = <T extends number | string>(
    appliedRule: IAppliedRule<T>,
    highlightedElementId: string,
    answerIndexOrId: T
): boolean => {
    const predicate = appliedRule.predicates[0];
    const result = appliedRule.results[0];
    const isSameElement = predicate.elementId === highlightedElementId;
    const isSameAnswer = predicate.answers.includes(answerIndexOrId);

    return isSameElement && isSameAnswer && predicate.operator === RuleOperator.IF && result.resultType === RuleResultType.SHOW_SLIDES;
};
